<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sKXCcP/tc-custom/9783988268587.jpg?1704453168009" alt="This image is the cover for the book Maurice and the Bay Mare & Lost Farm Camp, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maurice and the Bay Mare & Lost Farm Camp, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Maurice and the Bay Mare follows the adventures of the titular character, Maurice, a rugged and skilled cowboy in the American West. The heart of the story centers around Maurice's connection with a remarkable bay mare, a spirited and highly prized horse. "Lost Farm Camp" is a tale that paints a vivid picture of life in the American West during a time when the frontier was still being explored and settled. It provides a glimpse into the challenges and rewards of living amidst the beauty and harsh realities of the untamed land.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Herbert Knibbs
      </h2>
      
      <p class="authorDescription body article">Henry Herbert Knibbs (January 24, 1874 – February 10, 1945) was an American poet, journalist, and author known for his Western poetry and cowboy-themed works. He gained popularity during the early 20th century for his ability to capture the essence of the American West in his poetry and storytelling.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ee69aca